<div class="bg-white flex flex-col rounded-2xl"
  style="padding: 28px 24px 32px 24px; align-items: flex-start; gap: 10px; width: 100%; max-width: 429px; max-height: 90vh; overflow-y: auto;">

  <div class="flex flex-col gap-5 items-start w-full">

    <div class="flex flex-col gap-7 items-start w-full">

      <div class="flex flex-col gap-1.25 items-start font-body text-[#212121]">
        <p style="font-size: 15px; font-weight: 700; line-height: normal;">
          Ingresar en tu cuenta
        </p>
        <p class="font-normal leading-[normal]  text-[12px]">
          ¿No tienes cuenta?
          <button class="cursor-pointer  bg-transparent border-none p-0 hover:text-rojo-brillante! hover:underline" (click)="goToRegister()">
            Regístrate ahora
          </button>
        </p>
      </div>

      <div class="flex flex-col items-start w-full gap-4.25">

        <div class="flex flex-col gap-1 items-start w-full">
          <label
            style="font-family: 'Bahnschrift', sans-serif; font-size: 12px; font-weight: 700; color: #212121; line-height: normal;">
            E-Mail
          </label>
          <input class="auth-input" type="email" placeholder="Ingresa tu mail" [(ngModel)]="email" name="email"
            autocomplete="email" />
        </div>

        <div class="flex flex-col gap-0.75 items-start w-full">
          <label
            style="font-family: 'Bahnschrift', sans-serif; font-size: 12px; font-weight: 700; color: #212121; line-height: normal;">
            Contraseña
          </label>
          <input class="auth-input" type="password" placeholder="Ingresa tu contraseña" [(ngModel)]="password"
            name="password" autocomplete="current-password" />
        </div>

      </div>

      <div class="captcha-box" style="margin-bottom: 28px;">
        <div class="captcha-check" [class.checked]="captchaChecked" (click)="captchaChecked = !captchaChecked"></div>
        <span class="captcha-label">No soy robot</span>
        <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/recaptcha-logo.png" alt="reCAPTCHA"
          class="captcha-logo" />
      </div>

    </div>

    <button
      class="font-display text-white uppercase cursor-pointer transition-colors duration-200 bg-rojo-brillante border-0 h-9 text-[20px] w-full rounded-2xl"
      style="padding: 0 40px; line-height: 20px;" (click)="signIn()">
      Ingresar
    </button>

  </div>
</div>
